import { clearAuthHeaders } from "@/api/service"
import { getTgUserId } from "@/helpers/tgWebApp"

export const TG_USER_ID_STORAGE_KEY = "tgUserId"

export const readStoredTgUserId = (): string | null =>
  localStorage.getItem(TG_USER_ID_STORAGE_KEY)

export const storeTgUserId = (id: number): void => {
  localStorage.setItem(TG_USER_ID_STORAGE_KEY, String(id))
}

export const shouldDropStoredSession = (
  storedTgUserId: string | null,
  launchTgUserId: number | undefined
): boolean =>
  launchTgUserId !== undefined && storedTgUserId !== String(launchTgUserId)

export const dropForeignTelegramSession = (): void => {
  if (!shouldDropStoredSession(readStoredTgUserId(), getTgUserId())) {
    return
  }

  clearAuthHeaders()
  localStorage.removeItem(TG_USER_ID_STORAGE_KEY)
}
